(function () {
  'use strict';

  function initBankPromotions(root) {
    if (!root || root.dataset.bankPromotionsReady === 'true') return;

    var slides = Array.prototype.slice.call(
      root.querySelectorAll('[data-bank-promotions-slide]')
    );
    var dots = Array.prototype.slice.call(
      root.querySelectorAll('[data-bank-promotions-dot]')
    );

    if (!slides.length) return;

    root.dataset.bankPromotionsReady = 'true';

    var currentIndex = 0;
    var timer = null;
    var interval = parseInt(root.dataset.interval || '3000', 10);
    var reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    function showSlide(nextIndex) {
      currentIndex = (nextIndex + slides.length) % slides.length;

      slides.forEach(function (slide, index) {
        var active = index === currentIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      var activeBackground = window
        .getComputedStyle(slides[currentIndex])
        .getPropertyValue('--bp-slide-bg')
        .trim();

      if (activeBackground) {
        root.style.setProperty('--bp-active-bg', activeBackground);
      }

      dots.forEach(function (dot, index) {
        var active = index === currentIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function stopTimer() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function startTimer() {
      stopTimer();
      if (slides.length < 2 || reducedMotion) return;

      timer = window.setInterval(function () {
        showSlide(currentIndex + 1);
      }, interval);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.getAttribute('data-bank-promotions-dot'), 10);
        showSlide(index);
        startTimer();
      });
    });

    root.addEventListener('mouseenter', stopTimer);
    root.addEventListener('mouseleave', startTimer);
    root.addEventListener('focusin', stopTimer);
    root.addEventListener('focusout', function (event) {
      if (!root.contains(event.relatedTarget)) startTimer();
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopTimer();
      } else {
        startTimer();
      }
    });

    showSlide(0);
    startTimer();
  }

  function initAllBankPromotions(scope) {
    var container = scope || document;
    var sections = container.querySelectorAll('[data-bank-promotions]');

    sections.forEach(function (section) {
      initBankPromotions(section);
    });
  }

  initAllBankPromotions();

  if (!window.__bankPromotionsEventsBound) {
    window.__bankPromotionsEventsBound = true;

    document.addEventListener('shopify:section:load', function (event) {
      initAllBankPromotions(event.target);
    });

    document.addEventListener('shopify:section:reorder', function () {
      initAllBankPromotions();
    });
  }
})();
